import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors, theme } from "../../theme/theme";
import { SearchOutlined } from "@mui/icons-material";
import EventsCard from "../Events/EventsCard";

const EventsList = ({ eventsList = [] }) => {
  const [search, setSearch] = useState("");
  return (
    <Box sx={{ width: "100%", flex: 1 }}>
      {/* <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-SemiBold",
          fontSize: "18px",
          textAlign: "center",
          mb: 1,
        }}
      >
        Find hosts wherever I’m going:
      </Typography>
      <TextField
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "transparent",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
            fontWeight: "400",
            borderRadius: "9px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "9px",
              border: `1px solid  ${colors.secondary}}`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${colors.secondary}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${colors.secondary}`,
            },
            "& .MuiOutlinedInput-input": {
              color: "#fff",
            },
          },
        }}
        type={"text"}
        placeholder={"Where are you going?"}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          sx: {
            height: "50px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "9px",
            },
          },

          endAdornment: (
            <InputAdornment position="start">
              <SearchOutlined
                sx={{
                  color: "#fff",
                  fontSize: "20px",
                }}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          shrink: false,
        }}
      /> */}

      <Box>
        <Typography sx={[theme.subHeading, { mt: 2, mb: 1 }]}>
          Upcoming Events {"(" + eventsList?.length + ")"}
        </Typography>
        {eventsList?.length === 0 ? (
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-Regular",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            No events found
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {eventsList?.map((item, index) => (
              <EventsCard key={index} item={item} />
            ))}
          </Box>
        )}
        {/* <EventsCard item={eventsList} /> */}
      </Box>
    </Box>
  );
};

export default EventsList;
